import { Component, OnInit } from '@angular/core';
import {GlobalErrorService} from '../error/error.service';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-error-toast',
  templateUrl: './error-toast.component.html',
  styleUrls: ['./error-toast.component.scss']
})
export class ErrorToastComponent implements OnInit {
  error$: Observable<any>;

  constructor( private errorService: GlobalErrorService, ) { }

  ngOnInit() {
    this.error$ = this.errorService.get().map(error => {
      console.log(error);
      return error;
    });
  }

  closeAlert() {
    this.errorService.set(false);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/error-toast/error-toast.component.ts